import React from 'react'
import useScrollReveal from '../../hooks/useScrollReveal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faWallet,
  faArrowRightArrowLeft,
  faCalendarCheck,
  faFileImport,
  faChartPie,
  faReceipt,
} from '@fortawesome/free-solid-svg-icons'

const FEATURES = [
  {
    icon: faWallet,
    name: 'Multi-comptes & partage',
    desc: 'Créez autant de comptes que nécessaire et partagez-les avec votre famille ou votre partenaire.',
  },
  {
    icon: faArrowRightArrowLeft,
    name: 'Transactions & catégories',
    desc: "Suivez chaque transaction avec des catégories, sous-catégories et détails sur le bénéficiaire.",
  },
  {
    icon: faCalendarCheck,
    name: 'Échéanciers récurrents',
    desc: 'Programmez vos paiements récurrents et anticipez vos dépenses automatiquement.',
  },
  {
    icon: faFileImport,
    name: 'Import CSV intelligent',
    desc: 'Importez vos relevés bancaires grâce à un assistant guidé qui mappe colonnes et catégories.',
  },
  {
    icon: faChartPie,
    name: 'Dashboard & Analytics',
    desc: 'Visualisez vos dépenses avec des graphiques interactifs : donut, barres, courbes, et plus.',
  },
  {
    icon: faReceipt,
    name: 'Tickets de caisse',
    desc: 'Photographiez et conservez vos tickets, liés directement à vos transactions.',
  },
]

export default function Features() {
  const [ref, isVisible] = useScrollReveal()

  return (
    <section id="features" className={`section-padding reveal${isVisible ? ' revealed' : ''}`} ref={ref}>
      <h2 className="section-title">Tout ce qu'il faut pour gérer vos finances.</h2>
      <p className="section-subtitle">Des outils puissants dans une interface simple et intuitive.</p>
      <div className="landing-features">
        <div className="landing-features__grid">
          {FEATURES.map((f, i) => (
            <div className="landing-features__card" key={i}>
              <div className="landing-features__icon">
                <FontAwesomeIcon icon={f.icon} />
              </div>
              <h3 className="landing-features__name">{f.name}</h3>
              <p className="landing-features__desc">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
